interface IconContainerProps {
  children: React.ReactNode
  className?: string
}

export const IconContainer: React.FC<IconContainerProps> = ({
  children,
  className = "",
}) => (
  <div
    className={`-ml-0.5 flex h-4 w-4 items-center justify-center ${className}`}
  >
    {children}
  </div>
)
